type ClientSitePreviewProps = {
  image: string;
  title: string;
  url: string;
  sizes: string;
  loading?: 'eager' | 'lazy';
  className?: string;
};

export function ClientSitePreview({
  image,
  title,
  url,
  sizes,
  loading = 'lazy',
  className = '',
}: ClientSitePreviewProps) {
  const domain = url.replace(/^https?:\/\/(?:www\.)?/, '').replace(/\/$/, '');

  return (
    <div className={`client-site-preview ${className}`.trim()}>
      <div className="client-site-preview__bar" aria-hidden="true">
        <span className="client-site-preview__lights"><i /><i /><i /></span>
        <span className="client-site-preview__domain">{domain}</span>
        <span className="client-site-preview__status"><i /> Live client site</span>
      </div>
      <picture>
        <source
          srcSet={`${image}-400w.webp 400w, ${image}-800w.webp 800w, ${image}-1280w.webp 1280w`}
          sizes={sizes}
          type="image/webp"
        />
        <img
          className="client-site-preview__image"
          src={`${image}.png`}
          alt={`${title} website built by Verno Web`}
          width="1280"
          height="720"
          loading={loading}
        />
      </picture>
    </div>
  );
}
